import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { FormGroup, FormControl } from '@angular/forms';
import { IAppDataStore } from '@pershing/pershing-core';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';

@Component({
    selector: 'exchange-agreement-nyse-p',
    templateUrl: './exchange-agreement-nyse-p.component.html'
})
export class ExchangeAgreementNYSEPComponent implements OnInit {
    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;

    isbuttonDisabled = true;
    newwindow: any;
    form: FormGroup;
    deviceType: string = 'desktop';
    constructor(
        private translationService: PershingTranslationService, private dialog: MatDialog,
        private appDataStore: IAppDataStore, private tradingService: TradingService, @Optional() @Inject('AppSettings') appSettings: any) {
            // this.translationService.addTranslationFolder('@pershing/nxi-ng-miscellaneous', 'node_modules/@pershing/nxi-ng-miscellaneous/src');
            if (!!appSettings.deviceType) {
                this.deviceType = appSettings.deviceType;
            }
    }
    ngOnInit() {
        this.form = new FormGroup({
            agreementIdOne: new FormControl('01')
        });
    }
    showCancelDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
    }
    nsdaq() {
        console.log('inside');
        if (this.form.valid) {
            let formdata = this.form.value;
            this.appDataStore.put('PROFDATA', formdata);
            // this.router.navigate(['/nxi/exchangeagnsdaq'], { queryParamsHandling: 'preserve' });
            // document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
            //     detail: {
            //         titleValue: 'exchangeagnsdaq'
            //     }
            // }));
            this.tradingService.setExchangeAgreementDialogState('exchangeagnsdaq');
        }
    }
    checkCheckBoxvalue(event: any) {
        console.log(event.checked);

        if (event.checked) {
            this.isbuttonDisabled = false;
        } else {
            this.isbuttonDisabled = true;
        }
    }

}
